import React from 'react';

import BaseFilter from './Filter';
import FilterCheckbox from './fields/FilterCheckbox';
import FilterDatePicker from './fields/FilterDatePicker';
import FilterDateRangePicker from './fields/FilterDateRangePicker';
import FilterMultiSelect from './fields/FilterMultiSelect';
import FilterNumberRangeInput from './fields/FilterNumberRangeInput';
import FilterSelect from './fields/FilterSelect';

export class Filter extends React.Component {
  static Checkbox = FilterCheckbox;
  static DatePicker = FilterDatePicker;
  static DateRangePicker = FilterDateRangePicker;
  static NumberRangeInput = FilterNumberRangeInput;
  static Select = FilterSelect;
  static MultiSelect = FilterMultiSelect;

  render() {
    const { children, ...props } = this.props;

    return <BaseFilter {...props}>{children}</BaseFilter>;
  }
}

export default Filter;
